import httpService from './httpService';
import jwt from 'jsonwebtoken';
import { tokenService } from './tokenService';
export const userService = {
  login,
  logout,
  signup,
  query,
  getById,
  remove,
  update,
  getNewToken,
  getUser,
};
export class AuthError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}
export class NetworkError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}
var refreshTimeout = null;
function query() {
  return httpService.get('user');
}

function getById(userId) {
  return httpService.get(`user/${userId}`);
}
function remove(userId) {
  return httpService.delete(`user/${userId}`);
}

function update(user) {
  return httpService.put(`user/${user._id}`, user);
}
function getUser() {
  const token = tokenService.getToken();
  return token ? jwt.decode(token) : null;
}
async function login(userCred) {
  try {
    const { accessToken, refreshToken } = await httpService.post(
      'auth/login',
      userCred,
    );
    const user = jwt.decode(accessToken);
    _handleLogin(accessToken, refreshToken);
    httpService.setHeader();
    httpService.mount401Interceptor();
    return { user, accessToken };
  } catch (err) {
    if (!err.response) throw new NetworkError(503, err.message);
    if (err.response.status === 401)
      throw new AuthError(err.response.status, err.response.data.detail);
  }
}
async function signup(userCred) {
  return await httpService.post('auth/signup', userCred);
  // return _handleLogin(user)
}
function logout() {
  httpService.post('auth/logout');
  tokenService.removeToken();
  tokenService.removeRefreshToken();
  localStorage.removeItem('user');
  httpService.removeHeader();
  httpService.unmount401Interceptor();
}
// async function getLoggedUser() {
//     let user = localStorage.getItem('user')
//     if (!user || user === 'undefined') return null
//     user = JSON.parse(user)
//     const expiresIn = user.exp * 1000 - Date.now()
//     if (expiresIn < 0) {
//         return await getNewToken()
//     }
//     _setRefreshInterval(expiresIn)
//     return user
// }
async function getNewToken() {
  const oldRefreshToken = tokenService.getRefreshToken();
  // try {
  const { accessToken, refreshToken } = await httpService.post('auth/token', {
    refreshToken: oldRefreshToken,
  });
  tokenService.saveToken(accessToken);
  tokenService.saveRefreshToken(refreshToken);
  httpService.setHeader(accessToken);
  // const user = jwt.decode(accessToken)
  // const expiresIn = user.exp * 1000 - Date.now()
  // if (expiresIn < 0) return null
  // _setRefreshInterval(expiresIn)
  // _handleLogin(user, accessToken, refreshToken)
  return accessToken;
  // } catch (err) {
  //     logout()
  //     return null
  // }
}
function _handleLogin(accessToken, refreshToken) {
  tokenService.saveToken(accessToken);
  tokenService.saveRefreshToken(refreshToken);
}
function _setRefreshInterval(expiresIn) {
  if (refreshTimeout) return clearTimeout(refreshTimeout);
  refreshTimeout = setTimeout(getNewToken, expiresIn);
}
